import { connect } from 'react-redux';
import { reset } from 'redux-form';

import addAbilityToOpenModal from '../../../utilities/modalHOC';
import { updateSelectedCycleAction } from '../../Cycles/actions';
import { loadArchivedCycles, loadCycles } from '../../Cycles/actionsSagas';
import { getCycles, getSelectedCycle } from '../../Cycles/selectors';
import { getPermissions, getUser } from '../../Login/selectors';
import { updateRate } from '../../Rates/actions';
import { createRate, loadRates } from '../../Rates/actionsSagas';
import {
  getPagination,
  getRate,
  getRates,
  getWaiting,
} from '../../Rates/selectors';
import {
  getDutyStateReferences,
  getRankReferences,
} from '../../References/selectors';
import {
  examReceivedAction,
  setActualState,
  setIsRevertChecked,
  setIsUndoChecked,
  setRateBibliographyJson,
  setRateChapterQuestionsReport,
  setRatingExamQuestions,
  setUndoState,
  updateCheckedReferences,
  updateCycleAction,
  updateDutyState,
  updateDutyStates,
  updateRank,
  updateRanks,
  updateSelectedListTab,
} from '../actions';
import {
  createChapterActionSagas,
  createReferenceActionSagas,
  getRateRatingExamQuestions,
  loadExam,
  loadRateBibliographyJson,
  loadRateChapterQuestionsReport,
  loadReferences,
  submitBibliographyActionSagas,
} from '../actionsSagas';
import {
  getActiveListTab,
  getActualState,
  getBibliographyJson,
  getCheckedReferences,
  getCycle,
  getDutyState,
  getDutyStates,
  getIsRevertChecked,
  getIsUndoChecked,
  getOriginalCheckedReferences,
  getRank,
  getRanks,
  getRateChapterQuestionsReport,
  getRatingExamQuestions,
  getReferences,
  getReferencesImmutable,
  getUndoState,
  loadingExam,
  loadingGrid,
} from '../selectors';
import NewBibliographies from './NewBibliographies';

const mapStateToProps = (state) => ({
  rates: getRates(state),
  references: getReferences(state),
  referencesImmutable: getReferencesImmutable(state),
  checkedReferences: getCheckedReferences(state),
  dutyState: getDutyState(state),
  rank: getRank(state),
  cycles: getCycles(state),
  loadingExam: loadingExam(state),
  loadingGrid: loadingGrid(state),
  cycle: getCycle(state),
  isUndoChecked: getIsUndoChecked(state),
  isRevertChecked: getIsRevertChecked(state),
  waiting: getWaiting(state),
  ratesPagination: getPagination(state),
  rate: getRate(state),
  permissions: getPermissions(state),
  user: getUser(state),
  ranks: getRanks(state),
  dutyStates: getDutyStates(state),
  rankReferences: getRankReferences(state),
  dutyStateReferences: getDutyStateReferences(state),
  activeListTab: getActiveListTab(state),
  selectedCycle: getSelectedCycle(state),
  originalCheckedReferences: getOriginalCheckedReferences(state),
  ratingExamQuestions: getRatingExamQuestions(state),
  bibliographyJson: getBibliographyJson(state),
  rateChapterQuestionsReport: getRateChapterQuestionsReport(state),
  getUndoState: getUndoState(state),
  getActualState: getActualState(state),
});

const mapDispatchToProps = (dispatch) => ({
  setUndoState: (undoState) => dispatch(setUndoState(undoState)),
  setActualState: (actualState) => dispatch(setActualState(actualState)),
  setIsUndoChecked: (undoChecked) => dispatch(setIsUndoChecked(undoChecked)),
  setIsRevertChecked: (revertChecked) =>
    dispatch(setIsRevertChecked(revertChecked)),
  loadRates: () => dispatch(loadRates(null, true)),
  loadReferences: (id, type) => dispatch(loadReferences(id, type)),
  updateCheckedReferences: (references) =>
    dispatch(updateCheckedReferences(references)),
  updateCycle: (cycle) => dispatch(updateCycleAction(cycle)),
  createReference: (fields, rate) => {
    dispatch(createReferenceActionSagas(fields, rate, 'rate'));
  },
  createChapter: (fields) => {
    dispatch(createChapterActionSagas(fields));
  },
  updateDutyState: (dutyState) => dispatch(updateDutyState(dutyState)),
  updateRank: (rating) => dispatch(updateRank(rating)),
  submitBibliography: (bibliography) =>
    dispatch(submitBibliographyActionSagas(bibliography)),
  loadCycles: () => dispatch(loadCycles()),
  loadExam: (dutyState, rank, rate, cycle) =>
    dispatch(loadExam(dutyState, rank, rate, cycle)),
  createRate: (fields) => dispatch(createRate(fields)),
  updateRate: (rate) => dispatch(updateRate(rate)),
  updateRanks: (ranks) => dispatch(updateRanks(ranks)),
  updateDutyStates: (dutyStates) => dispatch(updateDutyStates(dutyStates)),
  loadExamNoCycle: () => dispatch(examReceivedAction({ chapters: [] })),
  onUpdateSelectedListTab: (tab) => dispatch(updateSelectedListTab(tab)),
  updateSelectedCycle: (cycle) => {
    dispatch(reset('CycleForm'));
    dispatch(updateSelectedCycleAction(cycle));
  },
  loadArchivedCycles: () => {
    dispatch(loadArchivedCycles());
  },
  getRateRatingExamQuestions: (rate, rank, dutyState, cycle) => {
    dispatch(getRateRatingExamQuestions(rate, false, cycle));
  },
  setRatingExamQuestions: (ratingExamQuestion) => {
    dispatch(setRatingExamQuestions(ratingExamQuestion));
  },
  loadRateBibliographyJson: (rateId) => {
    dispatch(loadRateBibliographyJson(rateId));
  },
  loadRateChapterQuestionsReport: (rateId) => {
    dispatch(loadRateChapterQuestionsReport(rateId));
  },
  clearBibJson: () => {
    dispatch(setRateChapterQuestionsReport());
    dispatch(setRateBibliographyJson());
  },
});

export default addAbilityToOpenModal(
  connect(mapStateToProps, mapDispatchToProps)(NewBibliographies),
);
